module.exports = __webpack_public_path__ + "img/IMG_0577_8_9_L_Black_MockedUp.c6ee2868.jpg";